export default __webpack_public_path__ + "static/media/birdsAmbience.bb784e68.wav";